export const SESSION_DEBUG_LOGS_ENABLED = import.meta.env.VITE_SESSION_DEBUG_LOGS_ENABLED === 'true';
export const ACTIVITY_CHECK_INTERVAL_MS = parseInt(import.meta.env.VITE_ACTIVITY_CHECK_INTERVAL_MINUTES || '5') * 60 * 1000;